import FeaturedDestinationContainerMobile from '../../../../components/containers/FeaturedDestinationContainerMobile';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFeaturedDestinations';

const cmpConfig = {
  name: 'featured-destination--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: FeaturedDestinationContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
